export function shouldAutoplayBackground({ mobile, reducedMotion, saveData }: {
  mobile: boolean;
  reducedMotion: boolean;
  saveData: boolean;
}) {
  return !mobile && !reducedMotion && !saveData;
}